module.exports = __webpack_public_path__ + "media/images/emblems/Herdern-7c272d822c5c0fbd176dce972875e38d.gif";